// Class: motion._Actuate.TweenTimer

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var TweenTimer = function(progress) {
	this.progress = progress;
}

// Meta

TweenTimer.__name__ = ["motion","_Actuate","TweenTimer"];
TweenTimer.__isInterface__ = false;
TweenTimer.prototype = {
	
};
TweenTimer.prototype.__class__ = TweenTimer.prototype.constructor = $hxClasses["motion._Actuate.TweenTimer"] = TweenTimer;

// Init



// Statics




// Export

exports.default = TweenTimer;